// React
import { FunctionComponent } from "react"

// UI components
import { Button } from "react-bootstrap"

// Styles
import "./VehicleIncidentsNoResults.css"

interface Props {
    callback?: VoidFunction
}

/**
 * Renders a "no results" view with a message, icon, and optional button.
 * Useful when no data is available in the Vehicle Incidents UI.
 */
const VehicleIncidentsNoResults: FunctionComponent<Props> = ({ callback }) => {
    return (
        <div className="VehicleIncidentsNoResults">
            <div className="VehicleIncidentsNoResultsHeader">
                <p>Nothing here...</p>
            </div>

            <div className="VehicleIncidentsNoResultsBody">
                <div className="VehicleIncidentsNoResultsIcon">
                    <span className="material-icons">cloud_off</span>
                </div>
            </div>

            <div className="VehicleIncidentsNoResultsFooter">
                {callback && (
                    <Button variant="primary" onClick={callback}>
                        Ok
                    </Button>
                )}
            </div>
        </div>
    )
}

export default VehicleIncidentsNoResults
